import { render } from "./AppointmentConfigListItem.vue?vue&type=template&id=4779b24e"
import script from "./AppointmentConfigListItem.vue?vue&type=script&lang=js"
export * from "./AppointmentConfigListItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__